export const consultas = [
  {
    categoria: "consultas",
    nombre: "Tirada simple por escrito",
    imagen: require("../img/normal.png"),   
    descripcion: "Consulta escrita con una tirada de 3 cartas.",
    precio: "2€ x pregunta",  
},
    {
    categoria: "consultas",
    nombre: "Tirada corta por videollamada",
    imagen: require("../img/simple.png"),
    descripcion: "Tirada de 30 minutos por videollamada.",
    precio: "15€",
},
    {
    categoria: "consultas",
    nombre: "Tirada completa por videollamada",
    imagen: require("../img/general.png"),
    descripcion: "Consulta de una hora por videollamada.",
    precio: "26€",
}
]